import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a57548dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = { class: "emailTitle" }
const _hoisted_3 = { style: {"color":"red","font-size":"14px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_mail_outlined = _resolveComponent("mail-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.t('validate.str9')), 1)
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_a_col, { span: 18 }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('validate.str10')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.formEmail.email]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_form, { model: _ctx.formEmail }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              class: "login-input",
              type: "tel",
              maxLength: 11,
              value: _ctx.formEmail.email,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formEmail.email) = $event)),
              disabled: true,
              placeholder: _ctx.t('login.placeholderStr6')
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_mail_outlined, { style: {"margin-right":"15px"} })
              ]),
              _: 1
            }, 8, ["value", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.code)), {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { class: "login-input" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      type: "tel",
                      maxLength: 6,
                      value: _ctx.formEmail.code,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formEmail.code) = $event)),
                      class: "login-input",
                      disabled: !_ctx.formEmail.email,
                      placeholder: _ctx.t('login.placeholderStr4')
                    }, null, 8, ["value", "disabled", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      disabled: _ctx.Disabled || !_ctx.formEmail.email,
                      onClick: _ctx.getMsg
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Disabled ? _ctx.btnTxt :_ctx.verificationCode), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16),
        _renderSlot(_ctx.$slots, "changeAccount", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["model"]),
    _renderSlot(_ctx.$slots, "login", {}, undefined, true)
  ]))
}